import LinkButton from '@/components/atoms/LinkButton';
import { CollectionInfoState } from '@/states/deviceDeliCollInfoState';
import { formatDateStringToJapanese } from '@/utils/commonFunc';
import url from '@/utils/config';
import { Constants } from '@/utils/constants';
import { useRecoilValue } from 'recoil';
import Heading from '../atoms/Heading';

type Prop = {
  isCollectionFlg: string;
  isOpen: boolean;
  onClose: () => void;
};

/**
 * 機器回収の希望日時をモーダルで確認し、必要に応じて集荷変更導線も出すポップアップ。
 * 配送系の手続きは誤認しやすいため、現在保持している回収情報をその場で再確認できるようにしている。
 */
const CollectionPopup = ({ isCollectionFlg, isOpen, onClose }: Prop) => {
  const collection = useRecoilValue(CollectionInfoState);
  // API は時間帯コードで保持しているため、表示時に名称へ引き直す。
  const pfdTime = Constants.ContractEntryCancel.DESIRED_PICK_UP_TIME_LIST.find(
    (time) => time.code === collection.collection_pfd_time
  );

  if (isOpen) {
    if (typeof window === 'object') {
      // 回収予定確認中の誤タップを防ぐため、背面スクロールを止める。
      document.body.style.overflow = 'hidden';
    }
    return (
      <>
        <div className='m-modal js-modal is-modal-fade is-modal-show' id='modal-use-01'>
          <div className='m-modal__inner'>
            <div className='m-modal__content'>
              <Heading as='h2'>回収情報</Heading>
              <Heading as='h3'>回収情報</Heading>
              {/* 回収予定は問い合わせ起点になりやすいため、日時だけを簡潔に確認できる形で出す。 */}
              <div className='m-table' style={{ marginLeft: '30px', marginRight: '30px' }}>
                <table>
                  <colgroup>
                    <col className='w-30' />
                    <col />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th className='m-table__th'>返却予定日時</th>
                      <td className='m-table__td'>
                        {/* 日付だけ、時間帯だけ登録されているケースもあるため、それぞれ欠けに耐える表示にする。 */}
                        {collection.collection_pfd_date === '' && !pfdTime?.name ? (
                          <span>-</span>
                        ) : (
                          <>
                            {collection.collection_pfd_date !== '' && (
                              <>
                                {formatDateStringToJapanese(collection.collection_pfd_date)}
                                <br />
                              </>
                            )}
                            {pfdTime?.name ?? (collection.collection_pfd_date !== '' ? '' : '-')}
                          </>
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className='m-button align-center'>
                {isCollectionFlg === '0' && (
                  // 回収変更が許可されている契約だけ、変更導線を出す。
                  <LinkButton variant='secondary' href='/top/delivery/change_collection/'>
                    {collection.recollection_flg === '0'
                      ? Constants.DeliCollInfo.Collection.COLLECTION_BUTTON
                      : Constants.DeliCollInfo.Collection.RECOLLECTION_BUTTON}
                  </LinkButton>
                )}
              </div>
            </div>
            <button
              type='button'
              onClick={onClose}
              className='m-modal__closeButton js-modal-coseButton'
            >
              <img
                className='m-modal__closeButtonImage'
                src={url('/images/icon_close.svg')}
                alt='閉じる'
                width='40'
                height='40'
              />
            </button>
          </div>
        </div>
        <span
          role='button'
          tabIndex={0}
          className='fn-overlay is-overlay-show'
          onClick={onClose}
          onKeyDown={onClose}
          aria-label='閉じる'
          data-testid='show'
        />
      </>
    );
  }
  if (typeof window === 'object') {
    document.body.style.overflow = '';
  }
  return <span className='fn-overlay' data-testid='hidden' />;
};

export default CollectionPopup;
